import { useState, useEffect } from 'react';
import { SESSION_TYPES } from '@medflex/utils/constants';
import useSessionChats from './useSessionChats';

const useSessionInternal1on1 = userId => {
  const { chats, isLoading, load, loadingStatus } = useSessionChats();
  const [session, setSession] = useState();

  useEffect(() => {
    if (loadingStatus === 'idle') {
      load();
    }
  }, [loadingStatus]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (chats && userId && !isLoading) {
      const result = chats.find(
        sessionChat =>
          sessionChat.type === SESSION_TYPES.INTERNAL1ON1 &&
          sessionChat.participants.length === 2 &&
          sessionChat.participants.some(participant => participant.userId === userId),
      );
      if (result) return setSession(result);
    }
  }, [chats, userId, isLoading]);

  return {
    sessionId: session && session.id,
  };
};

export default useSessionInternal1on1;
